import React, { useEffect, useState } from 'react';
import { isLocalDevelopmentHost } from '../../utils/localDevLayout';

const LocalDevBanner = () => {
  const isLocalDevelopment = isLocalDevelopmentHost();
  
  const [isScreenBuilder, setIsScreenBuilder] = useState(document.body.classList.contains('screenbuilder-active'));

  useEffect(() => {
    const checkScreenBuilder = () => {
      setIsScreenBuilder(document.body.classList.contains('screenbuilder-active'));
    };
    
    const observer = new MutationObserver(checkScreenBuilder);
    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (isLocalDevelopment && !isScreenBuilder) {
      document.documentElement.style.setProperty('--dev-banner-height', '32px');
      document.body.classList.add('local-dev-mode');
      return () => {
        document.documentElement.style.removeProperty('--dev-banner-height');
        document.body.classList.remove('local-dev-mode');
      };
    } else {
      document.body.classList.remove('local-dev-mode');
      document.documentElement.style.removeProperty('--dev-banner-height');
    }
  }, [isLocalDevelopment, isScreenBuilder]);

  if (!isLocalDevelopment || isScreenBuilder) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-[9999] h-8 bg-gray-900 dark:bg-gray-950 border-b border-gray-800 dark:border-gray-800">
      <div className="max-w-7xl mx-auto px-4 flex items-center justify-center gap-3 h-full">
        <span className="inline-block w-1.5 h-1.5 rounded-full bg-primary-400 dark:bg-primary-500" />
        <span className="text-xs font-medium tracking-wide text-gray-400 dark:text-gray-500 uppercase">
          Local Dev
        </span>
        <span className="text-[11px] font-mono text-gray-500 dark:text-gray-600">
          {window.location.host}
        </span>
      </div>
    </div>
  );
};

export default LocalDevBanner;
